import ChangelogBase from 'components/changelog-page/ChangelogBase'
import { graphql, useStaticQuery } from 'gatsby'
import { ReactElement } from 'react'
import getEnglishStrings from 'utils/getEnglishStrings'

export default function Ios(): ReactElement {
  const iOSData = useStaticQuery<Queries.iOSChangelogQuery>(graphql`
    query iOSChangelog {
      directus {
        application_changelog {
          strings {
            languages_code {
              code
            }
            ios_changelog_title
            ios_changelog_meta_description
            ios_changelog_meta_keywords
          }
        }
      }
    }
  `)

  const iosChangelogsStrings = getEnglishStrings(iOSData.directus?.application_changelog?.strings)

  return (
    <ChangelogBase
      metaData={{
        title: iosChangelogsStrings?.ios_changelog_title,
        meta_description: iosChangelogsStrings?.ios_changelog_meta_description,
        meta_keywords: iosChangelogsStrings?.ios_changelog_meta_keywords,
      }}
      title={iosChangelogsStrings?.ios_changelog_title}
      platform="ios"
    />
  )
}
